import createContextProxy from 'src/state/context/contextProxy'
import type { HubsStateType } from './HubsStateProvider'

const hubsStateProvider = createContextProxy<HubsStateType>('Hubs')

export const HubStateContext = hubsStateProvider.ContextProxy
export const HubsStateProvider = hubsStateProvider.ContextProxyProvider
export const useHubsState = hubsStateProvider.useProxy
export { defaultWidgetsValue } from './HubsStateProvider'
